/* Swatch-row scroller: shows/hides the chevrons on .wd-swatch-scroller and
   scrolls the row on click. Fully delegated (3 document-level listeners, zero
   per-card setup) so B4B colour-clones and AJAX-loaded cards work for free.
   Global version of the script that used to live in wd-main-collection.liquid
   — now serves every section using snippets/wd-card-swatches.liquid. */
(function () {
  function listOf(sc) { return sc.querySelector('.color-swatch-list--mini'); }

  function apply(sc, max, left) {
    sc.classList.toggle('has-overflow', max > 1);
    sc.classList.toggle('at-start', left <= 1);
    sc.classList.toggle('at-end', left >= max - 1);
  }

  function update(sc) {
    var l = listOf(sc);
    if (!l) return;
    apply(sc, l.scrollWidth - l.clientWidth, l.scrollLeft);
  }

  /* Half-swatch "peek" (lululemon parity), phones only.
     Without it the row is cut at whatever fraction the card width happens to
     land on — often a 1-2px sliver that reads as "the colours end here". We
     trim the row to a whole number of swatches PLUS half a swatch, so the cut
     always falls through the middle of a circle and the row visibly continues.
     Desktop keeps the full width because the chevrons already signal overflow. */
  function peekWidth(sc, l) {
    var sw = l.querySelector('.color-swatch');
    if (!sw) return null;
    var gap = parseFloat(getComputedStyle(l).columnGap || getComputedStyle(l).gap) || 0;
    var item = sw.getBoundingClientRect().width + gap;
    if (!item) return null;
    // The peek is what tells a phone user the row scrolls WHEN THERE ARE NO
    // CHEVRONS. Inside the PDP carousels the chevrons are shown (the row can't
    // be swiped there, the carousel owns the drag), and they already say
    // "there's more" — trimming as well would just cost swatches on an already
    // narrow card. So: chevrons visible → no trim.
    var arrows = sc.querySelectorAll('.wd-swatch-arrow');
    for (var i = 0; i < arrows.length; i++) {
      if (getComputedStyle(arrows[i]).display !== 'none') return null;
    }
    // Measure against the scroller, not the list: the list may already carry a
    // max-width from a previous pass, which would make it shrink on every resize.
    var avail = sc.clientWidth;
    if (!avail) return null;
    var n = Math.floor((avail - item / 2) / item);
    if (n < 1) return null;
    return n * item + item / 2;
  }

  var isPhone = function () {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  };

  // Read pass then write pass: with B4B expanding to hundreds of cards, an
  // interleaved read/write per scroller would force a reflow for each one.
  function refreshAll() {
    var phone = isPhone();
    var jobs = [];
    document.querySelectorAll('.wd-swatch-scroller').forEach(function (sc) {
      var l = listOf(sc);
      if (!l) return;
      var max = l.scrollWidth - l.clientWidth;
      jobs.push([sc, max, l.scrollLeft, l, phone && max > 1 ? peekWidth(sc, l) : null]);
    });
    jobs.forEach(function (j) {
      apply(j[0], j[1], j[2]);
      if (j[4]) {
        j[3].style.maxWidth = Math.round(j[4]) + 'px';
      } else {
        j[3].style.maxWidth = '';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.wd-swatch-arrow');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var sc = btn.closest('.wd-swatch-scroller');
    var l = sc && listOf(sc);
    if (!l) return;
    var d = Math.max(64, l.clientWidth * 0.75);
    l.scrollBy({ left: btn.classList.contains('wd-swatch-arrow--prev') ? -d : d, behavior: 'smooth' });
  });

  // scroll doesn't bubble — capture it; rAF-throttled.
  var raf = null;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.classList || !t.classList.contains('color-swatch-list--mini')) return;
    var sc = t.closest('.wd-swatch-scroller');
    if (!sc || raf) return;
    raf = requestAnimationFrame(function () { raf = null; update(sc); });
  }, true);

  // Initial + resize + new cards (B4B clones, Load More, filter swaps) — same
  // #facet-main scoping as the collection slider MutationObserver when present.
  var t;
  function debounced() { clearTimeout(t); t = setTimeout(refreshAll, 150); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
  window.addEventListener('load', refreshAll);
  window.addEventListener('resize', debounced);
  new MutationObserver(debounced)
    .observe(document.getElementById('facet-main') || document.body, { childList: true, subtree: true });
})();
